var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 23,
    viewBox: "0 0 19.999 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(-3.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_Notification",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.172,19H1a1,1,0,0,1-.893-1.451l1.67-3.309V9.222A7.232,7.232,0,0,1,6.022,2.643a3,3,0,0,1,5.958,0,7.233,7.233,0,0,1,4.243,6.579V14.24l1.67,3.309A1,1,0,0,1,17,19h-5.17a3,3,0,0,1-5.659,0ZM9,19ZM3.779,9.222v5.255a1,1,0,0,1-.107.451L2.626,17h12.75l-1.046-2.072a1,1,0,0,1-.107-.451V9.222a5.222,5.222,0,1,0-10.445,0Z",
    fill: "#b5b5be"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Notification-2",
    "data-name": "Notification",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(15)",
    fill: "#e0a422"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.895c6ede02cf1b3bb901329bb51a03b5.svg";
export { ForwardRef as ReactComponent };